<template>
  <div class="flex flex-col items-center gap-[12px] w-full">
    <div class="pb-[12px] w-full">
      <h2 class="text-[28px] max-md:text-[24px] font-bold text-[#3a3d44] text-center leading-[1.3]">
        Вход через email
      </h2>
    </div>
    <button
      class="bg-primary rounded-[12px] py-3 w-[368px] max-md:w-full text-white font-bold text-base"
      @click="$emit('setMode', LoginMode.EMAIL_PASSWORD)"
    >
      Уже есть аккаунт
    </button>
    <button
      class="bg-primary/[0.08] rounded-[12px] py-3 w-[368px] max-md:w-full text-primary font-bold text-base"
      @click="$emit('setMode', LoginMode.REGISTER_EMAIL)"
    >
      Зарегистрироваться
    </button>
  </div>
</template>

<script setup lang="ts">
import { LoginMode } from '~/interfaces/login/UI';

defineEmits<{
  (e: 'setMode', mode: LoginMode): void;
}>();
</script>
